export const airPricePredictionQuery = `query AirBuyPrediction($criteria: AirBuyPredictionInput!) {
  airBuyPrediction(criteria: $criteria) {
    recommendations {
      recommendation
      lowestPrice
      highestPrice
      maxPriceIncrease
      daysToMaxPrice
      belowLowerBound
      aboveUpperBound
      recommendationText
    }
  }
}`
